var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "18px",
    viewBox: "0 0 26 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Black/Arrow-Left") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buttons/Tertiary/Large-default",
    transform: "translate(-301.000000, -12.000000)",
    fill: "#50AFA8",
    stroke: "#50AFA8",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Black/Arrow-Left",
    transform: "translate(314.000000, 21.000000) scale(-1, 1) translate(-314.000000, -21.000000) translate(302.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9348727,8.24990476 L3.69981196,8.24990476 C3.491366,8.24990476 3.31925466,8.1127619 3.31925466,7.94361905 C3.31925466,7.7767619 3.491366,7.63961905 3.69981196,7.63961905 L22.9348727,7.63961905 C23.1480995,7.63961905 23.3192547,7.7767619 23.3192547,7.94361905 C23.3192547,8.1127619 23.1480995,8.24990476 22.9348727,8.24990476 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.02832605,15.8895238 C8.94698259,15.8895238 8.86643662,15.8598095 8.80104286,15.800381 L0.803864734,8.1607619 C0.744850855,8.10133333 0.710559006,8.02361905 0.710559006,7.94361905 C0.710559006,7.86285714 0.744850855,7.78590476 0.803864734,7.7287619 L8.80343532,0.0891428571 C8.92864044,-0.0297142857 9.13120159,-0.0297142857 9.25241929,0.0891428571 C9.37682693,0.208 9.37682693,0.40152381 9.25241929,0.520380952 L1.48013189,7.94361905 L9.25241929,15.3691429 C9.37682693,15.488 9.37682693,15.6815238 9.25241929,15.800381 C9.19021547,15.8598095 9.10887202,15.8895238 9.02832605,15.8895238 Z",
    id: "Fill-3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.2f97e8f6a7a46bb4ae470c7257fca5ce.svg";
export { ForwardRef as ReactComponent };